import EmployeeHeader from "../components/Employee/EmployeeHeader";
import EmployeeFiltersAndKPIs from "../components/Employee/EmployeeFiltersAndKPIs";
import EmployeeLeadsTable from "../components/Employee/EmployeeLeadsTable";

export default function EmployeePage() {
  return (
    <div className="bg-gray-50 min-h-screen">

      {/* Sticky Header */}
      <div className="sticky top-0 z-20 bg-white shadow-sm">
        <EmployeeHeader />
      </div>

      {/* Page Content */}
      <div className="px-2 py-6 space-y-6">
        <EmployeeFiltersAndKPIs />
        <EmployeeLeadsTable />
      </div>

    </div>
  );
}

